/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import WizardFunnel from '@/controls/WizardFunnel';
import { createStyles } from '@/utils/styles';
import { FlexBox, Title, Text } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import { useTranslations } from '../hooks/useTranslations';

type Props = {
    title: string;
    realm: string | undefined | null;
};
export default function HeaderNav({ title, realm }: Props) {
    const { t } = useTranslations();

    return (
        <FlexBox direction="Column" justifyContent="SpaceBetween" data-testId="header-nav" style={styles.wrapper}>
            <FlexBox justifyContent="SpaceBetween">
                <div style={styles.titleWrapper}>
                    <Title level="H3" size="H3">
                        {t('SET_UP_SKU', title)}
                    </Title>
                </div>
                {realm && (
                    <div style={styles.titleWrapper}>
                        <Text data-testId="realm-text">{t('REALM', realm)}</Text>
                    </div>
                )}
            </FlexBox>
            <div data-testId="icon-tab-header">
                <WizardFunnel />
            </div>
        </FlexBox>
    );
}

const styles = createStyles({
    wrapper: {
        backgroundColor: ThemingParameters.sapBaseColor,
    },
    titleWrapper: {
        padding: `${ThemingParameters.sapContent_Space_M} ${ThemingParameters.sapContent_Space_Large}  18px  ${ThemingParameters.sapContent_Space_Large}`,
    },
});
